import { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import SubMenu from "presentation/mobile/components/SubMenu";
import { MobileRoute, useNavigationStore } from "presentation/mobile/stores/navigation-store";
import { useAuthStore } from "presentation/stores/use-auth-store";

const MobileHome = () => {
    const { userName } = useAuthStore();
    const navigationStore = useNavigationStore();
    const [clickedButtonRoute, setClickedButtonRoute] = useState("");
    const navigate = useNavigate();

    const showSubMenu = useMemo(() => {
        return navigationStore.currentSubRoutes.length > 0;
    }, [navigationStore.currentSubRoutes]);

    useEffect(() => {
        if (navigationStore.currentRoute !== "home") {
            navigationStore.setCurrentRoute("home");
        }
        if (!navigationStore.useSubMenu) {
            navigationStore.setCurrentSubRoutes([]);
        } else {
            navigationStore.setUseSubMenu(false);
        }
    }, []);

    const navigateToRoute = (route: string) => {
        navigationStore.setUseSubMenu(false);
        navigationStore.setPreviousRoute(navigationStore.currentRoute);
        navigate(route);
    };

    const getFirstName = (fullName: string | null) => {
        if (!fullName) return "";
        const nameParts = fullName.split(" ");
        return nameParts[0];
    };

    const getGreeting = () => {
        const hour = new Date().getHours();
        if (hour < 12) return "Bom dia";
        if (hour < 20) return "Boa tarde";
        return "Boa noite";
    };

    const clickCategory = (subRoutes: MobileRoute[], categoryLabel: string) => {
        if (subRoutes.length > 1) {
            navigationStore.setUseSubMenu(true);
        }
        navigationStore.setCurrentSubRoutes(subRoutes);
        navigationStore.setCurrentCategoryLabel(categoryLabel);
    };

    const renderMenuItem = (item: MobileRoute) => {
        if (item.name === "home") return null;

        const isPressed = clickedButtonRoute === item.name;
        const hasSubRoutes = item.subRoutes && item.subRoutes.length > 0;

        const handleClick = () => {
            if (hasSubRoutes) {
                clickCategory(item.subRoutes ?? [], item.label);
            } else {
                navigateToRoute(item.route);
            }
        };

        return (
            <div
                key={item.route}
                className="flex flex-column align-items-center justify-content-center cursor-pointer border-round-xl p-4 gap-3 transition-all transition-duration-200"
                style={{
                    width: "100%",
                    backgroundColor: isPressed ? "#EBF3FC" : "#FFFFFF",
                    border: isPressed ? "1.5px solid #0084D1" : "1px solid #E2E8F0",
                    boxShadow: isPressed
                        ? "0 4px 14px rgba(0, 132, 209, 0.1)"
                        : "0 1px 3px rgba(0, 0, 0, 0.04)",
                    transform: isPressed ? "scale(0.98)" : "scale(1)",
                }}
                onClick={handleClick}
                onPointerDown={() => setClickedButtonRoute(item.name)}
                onPointerUp={() => setClickedButtonRoute("")}
                role="button"
            >
                {/* Contentor de Ícone Squircle */}
                <div
                    className="flex align-items-center justify-content-center border-round-xl"
                    style={{
                        width: "48px",
                        height: "48px",
                        backgroundColor: "#EFF6FF",
                    }}
                >
                    <i
                        style={{ color: "#0084D1", fontSize: "1.35rem" }}
                        className={`${item.icon}`}
                    />
                </div>

                {/* Nome do Módulo */}
                <span className="font-semibold text-sm text-center text-800 line-height-2">
                    {item.label}
                </span>
            </div>
        );
    };

    if (showSubMenu) {
        return (
            <SubMenu
                routes={navigationStore.currentSubRoutes}
                categoryLabel={navigationStore.currentCategoryLabel}
            />
        );
    }

    return (
        <div className="flex flex-column align-items-center w-full pb-8">
            {/* Cabeçalho de Boas-vindas */}
            {userName && (
                <div className="w-full px-3 pt-3 pb-1 flex flex-column gap-1">
                    <span className="text-xl font-bold text-900">
                        {getGreeting()}, {getFirstName(userName)}!
                    </span>
                    <span className="text-xs text-500">
                        O que pretendes consultar hoje?
                    </span>
                </div>
            )}

            {/* Grelha de Atalhos Principais */}
            <div
                className="pt-3 px-3"
                style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(2, 1fr)",
                    gap: "1rem",
                    width: "100%",
                }}
            >
                {navigationStore.routes.map(renderMenuItem)}
            </div>
        </div>
    );
};

export default MobileHome;